/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BackupTaskTypes } from '@veeam-vspc/models/web-controllers';

import { core } from 'core/core-module';
import { transformBaseChartData } from 'views/pages/TrendsPage/helpers';

import type { BaseDataResponse } from 'core/services/transport/interfaces/base-data-response';
import type { LineChartData, TrendData } from '../../../../../interfaces';

const names = [
    { label: 'Replicas', type: BackupTaskTypes.BackupTask },
];

export class VmReplicasService {
    static fetchData({ reportingPeriodInfo }): Promise<LineChartData> {
        return core.transportService
            .request('Trends/CloudVmReplicas', { ...reportingPeriodInfo })
            .then((resp: BaseDataResponse<TrendData>) => transformBaseChartData(resp.data.trends, reportingPeriodInfo, names));
    }
}
